import { useSelector } from 'react-redux';

import { PortalNotification, selectSsoJTI } from '@cloud/shared';

import { HeaderPusher } from './Notification.styles';
import { useNotification } from './useNotification';

export function Notification() {
    const notification = useNotification();
    const ssoJTI = useSelector(selectSsoJTI);

    if (!notification) {
        return null;
    }

    return (
        <HeaderPusher>
            <PortalNotification {...notification} sessionId={ssoJTI} />
        </HeaderPusher>
    );
}
